import Cookies from 'js-cookie';
import { eventSHA, paramString } from '../../Constants/PaymentPage';
import { AddAddress, addressListFetcher } from '../../datafetchers/AddressPage';
import {
  apiCallCreateOrder,
  createCustomerId,
  mobileWebLogin,
} from '../../datafetchers/PaymentPage';
import {
  decodeUTF,
  decryptData,
  encryptData,
  getCartObject,
} from '../CartUtils';
import { fromB2G1CategoryPage } from '../commonUtils';
import { getUserIsLoggedIn, getWebUserId } from '../helper';
import { getAllOffers } from '../../datafetchers/productPage';
import { getApiEndpoint, getPublicUrl, getRazorPayKey } from '../../appconfig';
import { firePurchaseEvent } from './purchaseEvent';
import { uaeString } from '../ForeignUtils';
import { free_daiper_consultation_ids } from '../../components/CartOverlayContainer/Cart/Constants';
import { navigateToOrderSuccessNew } from '../redirections';
import { getAddressDataCartOffUser } from '../addressUtils';
import { cartDataInitializer } from '../CartUtils/CartCookieManger';
import { getUserCartData } from '../../datafetchers/CartWidget';
import { updateIsDefaultKey } from '../../components/AddressPage/utils';
import { getWebUserType } from '../getWebUserType';
import { addCartHandler } from '../addCartHandler';
import { userDataFetcher } from '../../datafetchers/productPage/userDataFetcher';

export const getFirstSavedAddressOfUser = async () => {
  const addressData = await addressListFetcher({
    web_user_id: !getUserIsLoggedIn() ? getWebUserId() : null,
  });
  return addressData?.data?.[0];
};

export const updateSelectedAddressForUser = async (setSelectedAddress) => {
  const address = await getFirstSavedAddressOfUser();
  localStorage.setItem('selectedAddress', JSON.stringify(address));
  setSelectedAddress(address);
};

export const getCartSHAData = () => localStorage.getItem(eventSHA);

export const getDecrpytedData = (encryptedData) => {
  const decryptedData = decryptData(encryptedData);
  return decryptedData ? JSON.parse(decryptedData) : {};
};

export const daiperInCart = (productIds) => {
  for (let i = 0; i < free_daiper_consultation_ids.length; i++) {
    let sku_id = free_daiper_consultation_ids[i];
    for (let j = 0; j < productIds?.length; j++) {
      let sku_id2 = productIds[j];
      if (sku_id == sku_id2) return true;
    }
  }
  return false;
};

export const updateOrderData = (orderData, discount, paymentMethod) => {
  const orderDetailsCopy = JSON.parse(JSON.stringify(orderData?.details));
  const freeDeliveryPrice = orderData?.PriceDetail?.freeDeliveryPrice;
  const userLoggedIn = getUserIsLoggedIn();

  // Add Web_user_id if logout
  if (!userLoggedIn) orderDetailsCopy['web_user_id'] = getWebUserId();
  // 1 for COD , 3 FOR Razorpay, 12 FOR Juspay
  orderDetailsCopy['orderDetails']['payment_mode'] =
    paymentMethod == 1 ? '1' : showJusPay() ? '12' : '3';

  // discount given using popup for online payments
  if (discount) orderDetailsCopy['orderDetails']['prepaid_discount'] = discount;
  else orderDetailsCopy['orderDetails']['prepaid_discount'] = 0;

  // initializing order status 5(payment initiated) for online payment
  orderDetailsCopy?.products?.forEach((p) => {
    p.order_status = '5';
  });

  if (Cookies.get('Aplicable_free_delivery') && freeDeliveryPrice > 0)
    orderDetailsCopy['orderDetails']['deliveryFreeUsingCoin'] = true;

  if (Cookies.get('browser_id') && !userLoggedIn)
    orderDetailsCopy['browser_id'] = Cookies.get('browser_id');
  if (
    orderDetailsCopy?.orderDetails?.payment_mode == '12' &&
    orderDetailsCopy?.orderDetails?.prepaid_discount >=
      orderData?.PriceDetail?.orderFinalPriceTotal
  ) {
    orderDetailsCopy['orderDetails']['payment_mode'] = '10';
  }
  return orderDetailsCopy;
};

export const canCreateLead = (orderDetails) => {
  let productIds = [];
  orderDetails?.products.forEach((product) =>
    productIds.push(product.product_id),
  );

  return fromB2G1CategoryPage() && daiperInCart(productIds);
};

export const createCustomer = async () => {
  const response = await createCustomerId();
  if (response?.success) {
    const customer_id = response?.data?.customer_id;
    return customer_id;
  }
  return null;
};

export const makeUserLogin = async (mobile) => {
  // if (!getUserIsLoggedIn() && paymentMethod != 1) {
  // prepaid login api
  // let mobileNumber = JSON.parse(Cookies.get("is_default"))?.mobile;
  let productIds = Cookies.get('cart_items') || '';

  const response = await mobileWebLogin(mobile, productIds);

  if (response?.success && response?.data) {
    let encryptedToken = response?.data;
    Cookies.set('lu', encryptedToken, '/');
    Cookies.set('user_guid', encryptedToken, '/');
    // let decryptedToken = crypto.AES.decrypt(
    //     encryptedToken,
    //     "7F6DAD1C5ABFB7498C4C736D174B2",
    // ).toString(crypto.enc.Utf8);
    Cookies.set('token', encryptedToken, {
      expires: 365,
      path: '/',
    });
    // Pending
    let userType = getWebUserType();
    let newUser;
    if (Cookies.get('shopper')) newUser = false;
    else newUser = true;
    const params = {
      userType,
      random: new Date().getTime(),
      newUser,
    };
    await fetchUserDetails(params);
    // saveCustomerHandler(paymentMethod, discount);
    return true;
  }
  // } else {
  //     if (paymentMethod == 1) {
  //         if (getIsUserLoggedIn()) {
  //             setShowOrderConfirmPopup(true);
  //         } else {
  //             setShowLoginPoup(true);
  //         }
  //         setCodPopupVisible(false);
  //     } else {
  //         setShowLoader(true);
  //         saveCustomerHandler(paymentMethod, discount);
  //     }
  // }
};

export const fetchUserDetails = async (params) => {
  const data = await userDataFetcher(params);
  const userData = data.user;
  Cookies.set('react_user_properties', JSON.stringify(userData), '/');
  if (userData.offerStrip) {
    Cookies.set('offer_strip_data', JSON.stringify(userData.offerStrip), '/');
  }
  if (userData?.language) {
    Cookies.set('language', data.language == 2 ? 'hi' : 'en');
  }
};

// Create Order

export const createOrder = async (orderData, paymentMethod, discount) => {
  const orderDetails = updateOrderData(orderData, discount, paymentMethod);
  let createLead = canCreateLead(orderDetails);
  const queryParam = new URLSearchParams(window.location.search);
  const type = queryParam.get('type');
  const browser_id = Cookies.get('browser_id')
    ? Cookies.get('browser_id')
    : null;
  const params = {
    prepaidConversion: false,
    isActiveForAfterPurchaseSpin: true,
    createLead,
    type,
    browser_id,
    user_type: getWebUserType(),
  };
  let encryptDetails = encryptData(orderDetails);
  let dataObject = {
    payload: encryptDetails,
  };
  //   let dataObject = orderDetails;
  return await apiCallCreateOrder(params, dataObject);
};

export const handleRedirectionAfterOrder = async (
  paymentMethod,
  apiResponse,
  customerId,
  discount,
  orderData,
  router,
  fromAddress,
) => {
  if (apiResponse) {
    await firePurchaseEvents(orderData?.details, apiResponse?.data, orderData);
    if (discount) apiResponse.data.amount -= discount * 100;
    const order_id = apiResponse?.data?.orderId;
    Cookies.remove('crm_data');
    if (apiResponse?.data?.payment_mode == '10') {
      Cookies.set('orderId', order_id, '/');
      localStorage.setItem('mode', '10');
      navigateToOrderSuccessNew(`${order_id}/success`, router);
    } else {
      switch (paymentMethod) {
        case 1:
          Cookies.set('orderId', order_id, '/');
          localStorage.setItem('mode', paymentMethod.toString());
          // if (!getUserIsLoggedIn()) {
          //     // setCodPopupVisible(false);
          //     // setShowLoginPoup(true);
          // }
          navigateToOrderSuccessNew(`${order_id}/success`, router);
          break;

        default:
          if (showJusPay())
            jusPayHandler(apiResponse?.data, router, fromAddress);
          else razorpayInitializeHandler(apiResponse?.data, customerId);

          break;
      }
    }
  }
};

const navigateToOrderSuccess = (path) => {
  let redirectUrl =
    getPublicUrl() + '/store/ordersuccess/' + path + window.location.search;
  window.location.href = redirectUrl;
};

export const razorpayInitializeHandler = (orderData, customerId) => {
  let userProperties = {};
  if (Cookies.get('react_user_properties')) {
    userProperties = JSON.parse(Cookies.get('react_user_properties'));
  }
  let option = getRazorPayRequriedData(orderData, customerId, userProperties);
  let rzp = new window.Razorpay(option);
  rzp.open();
};

export const jusPayHandler = (orderData, router, fromAddress) => {
  // For payment page to open after clicking back
  // if (fromAddress && getWebUserType() === "A") {
  //     window.location.href =
  //         orderData?.juspayData?.payment_links?.web + window.location.search;
  //     Cookies.set("paymentBack", true);
  // } else {
  window.location.href =
    orderData?.juspayData?.payment_links?.web + window.location.search;
  // }
  localStorage.setItem('orderId', orderData?.orderId);
};

export const getRazorPayRequriedData = (
  orderData,
  customerId,
  userProperties,
) => {
  const strKeyRazorPay = getRazorPayKey();
  const orderId = orderData.order_id;
  let domainUrl = getPublicUrl();
  let params = window?.location?.search;
  const apiEndpoint = getApiEndpoint();
  const order_id_num = orderData?.orderId;
  const orderSuccessUrl =
    `${domainUrl}/store/ordersuccess/${order_id_num}` + params;

  return {
    key: strKeyRazorPay,
    name: 'Mylo',
    description: 'mylofamily.com',
    theme: {
      color: '#EF4E5E',
      hide_topbar: 'true',
    },
    modal: {
      backdropclose: true,
      handleback: true,
    },
    customer_id: customerId,
    amount: orderData.amount,
    currency: orderData.currency,
    email: orderData.email,
    contact: orderData.contact,
    notes: orderData.notes,
    order_id: orderId,
    orderSuccessUrl: orderSuccessUrl,
    prefill: {
      // name: "Gaurav Kumar",
      // email: "gaurav.kumar@example.com",
      contact: orderData.contact,
    },
    // paymentErrorUrl: paymentErrorUrl,
    //   method: method,
    callback_url:
      apiEndpoint +
      'api/callbackRazorpay' +
      '' +
      '?id=' +
      userProperties?.user_id +
      '&order_id=' +
      order_id_num +
      '&prepaidConversion=' +
      false +
      '&payment_mode=' +
      orderData.payment_mode +
      '&platform=web',
  };
};

const firePurchaseEvents = async (details, apiData, orderData) => {
  const { fireOrderEvents } = firePurchaseEvent();
  const parent_order_id = apiData?.orderId;
  const deliveryTime = apiData?.deliveryTime;
  const offerId = apiData?.offerId;
  const orderIds = apiData?.orderIds;
  const data = details?.products;
  const orderDetails = details?.orderDetails;
  const mobile = orderDetails?.phone;
  const price_detail = orderData?.PriceDetail;
  const totalData = {
    data,
    mobile,
    parent_order_id,
    price_detail,
    deliveryTime,
    offerId,
    orderIds,
  };
  if (orderDetails?.payment_mode === '1') {
    await fireOrderEvents(totalData, 'checkout', orderDetails?.payment_mode);
  }
};

export const paymentMethodsToShow = () => {
  const paymentMethod = localStorage.getItem('filter_key') || '0';
  const queryParam = new URLSearchParams(window.location.search);
  // Cod payment Method to show paymentMethod is 1 or 0  and CampaignID specific and UAE user
  const showCod =
    (paymentMethod == '1' || paymentMethod == '0') &&
    !(
      queryParam.get('CampaignID') == '6258139631395' ||
      queryParam.get(paramString) === uaeString
    );
  const showOnlineMethods = paymentMethod == '2' || paymentMethod == '0';
  return {
    cod: showCod,
    online: showOnlineMethods,
  };
};

export const getOfferTopText = () => {
  return localStorage.getItem('appliedOfferName') || '';
};

export const pushSameRoute = (router, ParamToAdd) => {
  const params = new URLSearchParams(window.location.search);
  params.set(ParamToAdd, 'true');
  router.push('/store/payment' + '?' + params, undefined, {
    shallow: true,
    scroll: false,
  });
};
export const pushSameRouteMaternity = (router, ParamToAdd, query = null) => {
  const params = new URLSearchParams(window.location.search);
  params.set(ParamToAdd, 'true');
  if (query) {
    const keys = Object.keys(query);
    for (const key of keys) {
      params.set(key, query[key]);
    }
  }
  router.push(window.location.pathname + '?' + params, undefined, {
    shallow: true,
    scroll: false,
  });
};
export const pushSameRouteShareButton = (router, ParamToAdd) => {
  const params = new URLSearchParams(window.location.search);
  params.set(ParamToAdd, 'true');
  router.push(window.location.pathname + '?' + params, undefined, {
    shallow: true,
    scroll: false,
  });
};

export const delayFunc = (func, time) => {
  setTimeout(() => {
    func();
  }, [time]);
};

export const getOtpVerificationData = (orderData) => {
  let commaSeperatedIds;
  let commaSeperatedNames;
  orderData?.details?.products?.forEach((element) => {
    if (commaSeperatedIds || commaSeperatedNames) {
      commaSeperatedIds += ',' + JSON.stringify(element?.product_id);
      commaSeperatedNames += ',' + element?.product_nickname;
    } else {
      commaSeperatedIds = JSON.stringify(element?.product_id);
      commaSeperatedNames = element?.product_nickname;
    }
  });
  let obj = {
    conversion_param: orderData?.conversion_param,
    final_price: JSON.stringify(orderData?.total),
    id: commaSeperatedIds,
    sku_nickname: commaSeperatedNames?.substring(0, 98),
  };
  return obj;
};
export const getPaymentText = () => {
  // if (true)
  return { message: 'Pay Online', showImg: false };
  // return {
  //     message: "Pay Online Securely",
  //     showImg: true,
  // };
};
const default_address_keys = {
  address_type: '1',
  is_default: true,
  country: 'India',
  email: '',
  product_stage: '',
};
const updateAddressUser = async (addressData, sku_ids) => {
  addressData = { ...addressData, ...default_address_keys };
  addressData['web_user_id'] = getWebUserId;
  addressData['product_ids'] = sku_ids;
  const response = await AddAddress(addressData);
  if (response?.success && response?.data?.addressId) {
    Cookies.set('logoutUserId', response?.data?.newUserId, '/');
    updateIsDefaultKey(
      addressData,
      response?.data?.addressId,
      response?.data?.isPrepaidForWeb,
    );
  }
};
const updateRouteWithoutQuery = (router, search_params) => {
  search_params.delete('key');
  search_params.delete('sku_ids');
  search_params.delete('coupon');
  let redirect_url = window.location.pathname;
  if (search_params.toString().length > 0)
    redirect_url += '?' + search_params.toString();
  router.replace(redirect_url, undefined, {
    shallow: true,
    scroll: false,
  });
};

const getDecodedAddressData = (address_data) => {
  const dataArr = address_data?.split('.');
  address_data = decodeUTF(dataArr);
  address_data = getAddressDataCartOffUser(address_data);
  return address_data;
};
export const updateEventSHAData = (cartProducts) => {
  const dataObject = getCartObject(cartProducts);
  const dataObjectStringFied = JSON.stringify(getCartObject(cartProducts));
  const encryptedData = encryptData(dataObjectStringFied);
  localStorage.setItem('eventSHA', encryptedData);
};

const getCartDataOfUser = async (sku_ids, coupon) => {
  if (sku_ids) Cookies.set('cart_items', sku_ids);
  if (coupon) Cookies.set('coupon_code', coupon);
  let cartRequestData = cartDataInitializer();
  const data = await getUserCartData(cartRequestData);
  const cartProducts = data?.data;
  if (sku_ids) updateEventSHAData(cartProducts);

  return data;
};

export const handleCRMData = async (setCrmData, router) => {
  const search_params = new URLSearchParams(window.location.search);
  let sku_ids = search_params.get('sku_ids');
  const contains_crm_query = sku_ids ? true : false;
  const crm_cookie_exist = Cookies.get('crm_flow');

  if (!contains_crm_query && !crm_cookie_exist) return;
  const coupon = search_params.get('coupon');
  sku_ids = sku_ids || Cookies.get('cart_items');
  if (getUserIsLoggedIn()) await addCartHandler(sku_ids);
  let cart_data = await getCartDataOfUser(sku_ids, coupon);
  let offers_data = await getAllOffers(sku_ids, true);
  let address_data = search_params.get('key') || null;
  // Check if user has query and no cookie present // First Time User // CRM FLOW
  // if user has query and cookie  // Consider it first time user update it's data

  if (contains_crm_query && address_data) {
    address_data = getDecodedAddressData(address_data);
    updateAddressUser(address_data, sku_ids);
  }
  // if user doesn't have query and but have cookie
  //  Address  -> is_default_cookie
  // Cart, offers  -> Api hit
  else {
    address_data = Cookies.get('is_default')
      ? JSON.parse(Cookies.get('is_default'))
      : {};
  }
  updateRouteWithoutQuery(router, search_params);
  setCrmData({ address_data, cart_data, offers_data });
  Cookies.set('crm_flow', true);
};

export const checkIsCrmFlow = (query, crm_flow) => crm_flow || query.sku_ids;

export const showJusPay = () => {
  return true;
};
